<template>
  <v-table class="mt-1 table-striped">
    <tbody class="font-size-10-rem">
      <template
        v-for="symptomUsage in usagesBySymptoms"
        :key="symptomUsage.symptomId"
      >
        <tr>
          <td class="text-left w-75">
            {{ symptomUsage.symptomName }}
          </td>
          <td class="text-left">
            {{ symptomUsage.usages }}({{ symptomUsage.usagesPercent }}%)
          </td>
        </tr>
      </template>
    </tbody>
  </v-table>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue"
import { SymptomUsage } from "../../stores/store_types"

export default defineComponent({
  name: "SymptomUsagesPart",
  props: {
    usagesBySymptoms: {
      type: Array<SymptomUsage>,
      required: true
    },
  },
  setup(props) {
    const usagesBySymptoms = computed(() => props.usagesBySymptoms as  Array<SymptomUsage>)

    return {
      usagesBySymptoms
    }
  }
})
</script>
